import moment from 'moment-timezone'

export const calculateEventsOverlap = (events) => (
  events.reduce((acc, currentEvent, currentIndex) => {
    let nextEventIndex = currentIndex + 1
    let overlapCount = (acc[currentIndex] && acc[currentIndex].overlapCount) || 1

    const currentEventEnd = moment(currentEvent.end)
    let currentEventStart = moment(currentEvent.start)

    while (currentEventStart.isBefore(currentEventEnd) && nextEventIndex < events.length) {
      const nextEvent = events[nextEventIndex]
      const nextEventStart = moment(nextEvent.start)
      const nextEventOverlapCount = (acc[nextEventIndex] && acc[nextEventIndex].overlapCount) || 1

      if (nextEventStart.isBefore(currentEventEnd)) {
        overlapCount += 1
        acc[nextEventIndex] = { ...nextEvent, overlapCount: nextEventOverlapCount + 1 }
      }

      nextEventIndex += 1
      currentEventStart = nextEventStart
    }

    acc[currentIndex] = { ...currentEvent, overlapCount }

    return acc
  }, [])
)
